/**
 * NVZN3D AR Product Card — Click Handler
 * Reads data- attributes from server-rendered .nvzn3d-card-ar-btn buttons
 * and launches the floorapp preview. No JSON catalog needed.
 */
(function () {
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.nvzn3d-card-ar-btn');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        if (!window.Nvzn3D) {
            console.warn('[NVZN] Floorapp player not loaded yet');
            return;
        }

        Nvzn3D.displayFloorPreview({
            clientId: btn.dataset.clientId,
            imageUrl: btn.dataset.imageUrl,
            width: parseFloat(btn.dataset.width) || 0,
            length: parseFloat(btn.dataset.length) || 0,
            units: btn.dataset.units || 'cm'
        });
    });
})();